import React from 'react';
import { TimePicker, Button, Tooltip } from 'antd';
import moment from 'moment';
import { TIME_INPUT_FORMAT } from 'lib/helpers/dateFormats';

// The time half of a split date/time pair. The pairing itself is the framework's existing
// mechanism, not a new one: a `date` field naming `time_key`, and a `time` field naming
// `date_key` back. components/Form/index.js seeds this input from the DATE field's stored
// timestamp and, on submit, folds the hour/minute back into that timestamp -- this key never
// reaches the API. See resources/inspectionTimeBlock.js for the original use.
//
// What is new here is `nowButton`. It stamps BOTH halves, and that is the whole point: a bare
// time with no date is dropped by normalizeValues, so a Now that only filled the TimePicker
// would look like it worked and save nothing. Setting the date needs the form object, which
// is why this is a component receiving `form` (5th inputRender arg) rather than an
// actionRender -- those are only handed four arguments.
// Must match DateInput's PAIR_INPUT_WIDTH -- see the note there.
const PAIR_INPUT_WIDTH = '150px';

export default ({ item, values, form, value, onChange }) => {

    const stampNow = () => {
        // 🐛 SECONDS ARE DROPPED HERE ON PURPOSE (1786600051). A bare moment() carries seconds
        // and milliseconds, nothing in this app can display or edit them, and on the work-order
        // trip timeline they are BILLED: a Now-stamped 4:10:36 pm end made a four-hour call
        // read 4.01 hours. The database truncates these stamps to the minute as well -- that is
        // the enforcement, this is the fix at the source, and both are wanted because a stamp
        // that reaches the API with seconds on it would still round-trip back into this picker.
        const now = moment().seconds(0).milliseconds(0);
        onChange(now);
        if(item.date_key && form) {
            form.setFieldsValue({[item.date_key]: now});
        }
    };

    // getFieldDecorator hands us whatever initialValue the form resolved, which for a field
    // seeded off `date_key` is already a moment -- but a `time`-typed field with no date_key
    // can carry a raw string. TimePicker only accepts a moment.
    const time = value ? moment(value) : null;

    return <span>
        <TimePicker use12Hours style={{width: PAIR_INPUT_WIDTH}}
            format={item.timeFormat || TIME_INPUT_FORMAT}
            value={time}
            onChange={onChange} />
        {item.nowButton
            ? <Tooltip title="Now">
                <Button style={{marginLeft: '8px'}} icon="clock-circle" onClick={stampNow} />
              </Tooltip>
            : null}
        {item.quickTimes
            ? item.quickTimes.map(quickTime => {
                const blockedReason = item.quickTimeBlockedReason(form, values);
                return <Tooltip key={quickTime.label} title={blockedReason}>
                    <Button style={{marginLeft: '8px'}} size="small" disabled={!!blockedReason}
                        onClick={() => item.onQuickTime(quickTime, form, values, onChange)}>{quickTime.label}</Button>
                </Tooltip>;
            })
            : null}
    </span>;
};
